import { Avatar, Box, Divider, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BreadcrumbCustom, {
  BreadcrumbChild,
} from "../../components/BreadcrumbCustom/BreadcrumbCustom";
import CardTitleWithSubtitle from "../../components/CardTitleWithSubtitle/CardTitleWithSubtitle";
import CustomCard from "../../components/CustomCard/CustomCard";
import Layout from "../../components/Layout/Layout";
import OrderStatusProgress from "../../components/OrderStatusProgress/OrderStatusProgress";
import QueryPageTitleCard from "../../components/QueryPageTitleCard/QueryPageTitleCard";
import { StyledIcon } from "../../components/StyledIcon/StyledIcon";
import { routesConfig } from "../../config/routes";
import RoadScheduleRequestStep1 from "./Section/RoadScheduleRequestStep1";
import RoadScheduleRequestStep2 from "./Section/RoadScheduleRequestStep2";
import RoadScheduleRequestStep3 from "./Section/RoadScheduleRequestStep3";
import {
  RoadScheduleRequestProvider,
  useRoadScheduleRequestContext,
} from "./context/RoadScheduleRequestContext";

const ScheduleRequestPageContainer: React.FC = () => {
  const { step } = useRoadScheduleRequestContext();
  const navigate = useNavigate();

  const breadcrumbs: BreadcrumbChild[] = [
    {
      isIcon: true,
      link: routesConfig.HOME,
      icon: <StyledIcon iconType={"home"} />,
    },
    {
      link: routesConfig.OPERATIONAL().ROAD_STATIONS,
      label: "ENTREGAS RODOVIÁRIAS",
    },
    { label: "NOVO PEDIDO DE AGENDAMENTO" },
  ];

  const StepbyStep = [
    <RoadScheduleRequestStep1 key={0} />,
    <RoadScheduleRequestStep2 key={1} />,
    <RoadScheduleRequestStep3 key={2} />,
  ];

  return (
    <Layout
      enableMargin
      appBarProps={{
        notification: {
          onChange() {},
        },
        chat: {
          onChange() {},
        },
        settings: {
          onChange() {},
        },
        avatar: () => (
          <Avatar
            alt="Avatar"
            src="/images/avatar.png"
            sx={{
              width: 60,
              height: 60,
            }}
          />
        ),
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <QueryPageTitleCard title="Entregas rodoviárias" />
        </Grid>
        <Grid item xs={12}>
          <CustomCard
            sx={{
              boxShadow: "none",
              border: "1px solid #DFE0EB",
              height: "100%",
              padding: 2.4,
            }}
          >
            <CardTitleWithSubtitle
              title="Novo pedido de agendamento"
              buttonProps={{
                title: "Voltar para agendamentos",
                onClick: () => {
                  navigate(routesConfig.OPERATIONAL().ROAD_STATIONS);
                },
              }}
            />
            <BreadcrumbCustom data={breadcrumbs} />
            <Box mt={2}></Box>
            <Divider />
            <Grid container mt={5}>
              <Grid item xs={4} />
              <Grid item xs={4}>
                <OrderStatusProgress
                  statusList={[
                    {
                      icon: (
                        <StyledIcon
                          iconType={step === 0 ? "current-step" : "step"}
                          sx={{ width: "2rem", height: "2rem" }}
                        />
                      ),
                      description: "Agendamento",
                      isMarked: step === 0,
                    },
                    {
                      icon: (
                        <StyledIcon
                          iconType={step === 1 ? "current-step" : "step"}
                          sx={{ width: "2rem", height: "2rem" }}
                        />
                      ),
                      description: "Transportadora",
                      isMarked: step === 1,
                    },
                    {
                      icon: (
                        <StyledIcon
                          iconType={step === 2 ? "current-step" : "step"}
                          sx={{ width: "2rem", height: "2rem" }}
                        />
                      ),
                      description: "Pedido",
                      isMarked: step === 2,
                    },
                  ]}
                />
              </Grid>
              <Grid item xs={4} />
            </Grid>
            {StepbyStep[step]}
          </CustomCard>
        </Grid>
      </Grid>
    </Layout>
  );
};

const ScheduleRequestPage: React.FC = () => {
  return (
    <RoadScheduleRequestProvider>
      <ScheduleRequestPageContainer />
    </RoadScheduleRequestProvider>
  );
};
export default ScheduleRequestPage;
